import { LitElement, css, html } from 'lit';
import { repeat } from 'lit/directives/repeat.js';
import '../Inputbox/Input';
import { debounce } from '../../../lib/helpers';
import { formatUnixTimestamp } from '../../../utils/unixTimeConverter';
import '../../Components/Loader/Spinner/Spinner';
import { WEB_CONTENT } from '../../../constants/content';

class MesssageSearch extends LitElement {

  static properties = {
    searchedMessageDetails: { type: Array },
    onSearchResultClick: { type: Function },
    onSearchInput: { type: Function },
    isSearchOpen: { type: Boolean },
    isLoadingMessage: { type: Boolean },
    chatBodyRef: { type: HTMLBodyElement }
  };

  constructor() {
    super();
    this.isSearchOpen = true;
    this.searchValue = "";
    this.debouncedSearchHandler = debounce(query => {
      if (this.onSearchInput) {
        this.onSearchInput(query);
      }
    }, 500);
  }
  
  static styles = css`
.searchMessageContainer{
background-color:var(--bg-primary-color);
height:100%;
}
    .search-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      font-size: 18px;
    }

    .search-header h3 {
      margin: 0;
      color: var(--text-outgoing-message);
    }

    .close-search {
      background: none;
      border: none;
      color: var(--text-outgoing-message);
      cursor: pointer;
      font-size: 20px;
      padding: 5px;
    }
    
    .search-input-container {
      padding: 8px 16px;
      position: relative;
      display: flex;
      align-items: center;
    }
    
    .search-input {
      background-color: var(--bg-secondary-color);
      border-radius: 20px;
      color: var(--text-outgoing-message);
      border: none;
      padding: 8px 36px 8px 16px;
      width: 100%;
      height: 40px;
      font-size: 16px;
      outline: none;
    }
    
    .back-button {
      color: var(--text-outgoing-message);
      margin-right: 8px;
      cursor: pointer;
    }
    
    .clear-button {
      position: absolute;
      right: 24px;
      background: none;
      border: none;
      color: var(--text-outgoing-message);
      cursor: pointer;
    }

    .search-results {
      height: calc(100vh - 160px);
      overflow-y: auto;
    }

    .search-results-container {
      display: flex;
      flex-direction: column;
      padding: 12px 16px;
      border-bottom: 1px solid var(--bg-secondary-color);
      cursor: pointer;
    }
    
    .search-results-container span:first-child {
      color: var(--text-outgoing-message);
      margin-bottom: 4px;
    }
    
    .search-results-container span:last-child {
      color: var(--text-secondary-color);
      font-size: 14px;
    }

    .search-results-placeholder {
      display: flex;
      justify-content: center;
      align-items: center;
      height: calc(100vh - 160px);
      color: var(--text-secondary-color);
    }
    
    .result-item-name {
      color: var(--bg-incoming-message);
    }
    
    .check-icon {
      color: var(--bg-incoming-message);
      margin-right: 4px;
    }
    
    .date-label {
      padding: 12px 0px;
      color: var(--text-secondary-color);
      font-size: 14px;
    }
  `

  async handleSearchResultClick(messageId) {
    if (this.chatBodyRef) {
      await this.chatBodyRef.scrollToMessage(messageId);
    }
    if (this.onSearchResultClick) {
      this.onSearchResultClick(messageId);
    }
    this.searchedMessageDetails = [];
    this.dispatchEvent(new CustomEvent('close-right-Sidebar', {
      detail: {
        type: 'close-right-Sidebar',
      },
      bubbles: true,
      composed: true
    }));  }
  
  handleCloseSearch() {
        this.searchedMessageDetails = [];
    this.dispatchEvent(new CustomEvent('close-right-Sidebar', {
      detail: {
        type: 'close-right-Sidebar',
      },
      bubbles: true,
      composed: true
    }));
  }
  
  handleInputChange(e) {
    const searchText = e.target.value.toLowerCase();
    this.searchValue = searchText;
    this.debouncedSearchHandler(searchText);
    this.requestUpdate();
  }
  
  formatDate(timestamp) {
    const date = new Date(timestamp);
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  }
  
  render() {
    return (html`
        <div class="searchMessageContainer" @click=${(e) => e.stopPropagation()}>
          <div class="search-header">
            <h3>Search messages</h3>
            <button class="close-search" @click=${() => this.handleCloseSearch()}>
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor">
                <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
              </svg>
            </button>
          </div>
          <div class="search-input-container">
            <input 
              type="text" 
              class="search-input" 
              placeholder="Search" 
              .value=${this.searchValue}
              @input=${(e) => this.handleInputChange(e)} 
            />
            ${this.searchValue ? html`
              <button class="clear-button" @click=${() => {
                this.searchValue = '';
                this.searchedMessageDetails = [];
                this.requestUpdate();
              }}>
               <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor">
                <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
              </svg>
              </button>
            ` : ''}
          </div>
          <div class="search-results">
            ${this.isLoadingMessage 
      ? html`<div class="search-results-placeholder">
              <spinner-loader
                    height="15px"
                    width="15px"
                    spinTime="1s"
                    spinnerPrimaryColor="var(--bg-primary-color)"
                    spinnerSecondaryColor="var(--text-primary-color)"
                    spinnerBorderWidth="2px"
                  ></spinner-loader>
              </div>` 
              : this.searchedMessageDetails.length === 0 
        ? html`<div class="search-results-placeholder">${this.searchValue ? WEB_CONTENT.PLACEHOLDER_CONTENT.SEARCH_CHAT.NO_RESULTS_FOUND : WEB_CONTENT.PLACEHOLDER_CONTENT.SEARCH_CHAT.SEARCH_FOR_MSG}</div>`
                : html`
                  ${repeat(
                    this.searchedMessageDetails,
                    message => message.messageId,
                    message => html`
                      <div class="search-results-container" @click=${() => this.handleSearchResultClick(message.messageId)}>
                        <span class='date-label' >${formatUnixTimestamp(message.sentAt)}</span>
                        <span>${message.body}</span>
                      </div>
                    `
                  )}
                `
            }
          </div>
      </div>`
    )
  }
}

customElements.define('message-search', MesssageSearch);